import React from 'react'
import List from '@mui/material/List'
import { Typography } from '@mui/material'
import MailListItem from './MailListItem'
import useStyles from './styles/establishmentFormStyles'
import { generateRandomGuiID } from '../../utils/commonUtils'

export default function MailList(props: any) {
    const classes = useStyles()

    const { id, mails, required, callback } = props
    return (
        <>
            {required && mails.length === 0 && (
                <Typography className={classes.EstablishmentErrorText}>Un email doit être fourni</Typography>
            )}
            {mails && (
                <List dense={false}>
                    {mails.map((mail: string) => (
                        <MailListItem key={generateRandomGuiID()} id={id} mail={mail} callback={callback} />
                    ))}
                </List>
            )}
        </>
    )
}
